import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { toFormData } from 'src/app/helpers/form.utils';
import { ListResultDTO } from 'src/app/helpers/listResult.interface';
import { environment } from 'src/environments/environment';

import { ActionAttachmentDTO, ActionAttachmentFilters } from '../../models/action-attachment.model';

@Injectable({
  providedIn: "root"
})
export class LaravelActionAttachmentService {
  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {
      list: environment.baseUrl + "/api/action_attachments",
      show: environment.baseUrl + "/api/action_attachment",
      store: environment.baseUrl + "/api/action_attachment",
      destroy: environment.baseUrl + "/api/action_attachment",
    };
  }

  public list(page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: ActionAttachmentFilters,
    includes?: string[]
  ): Observable<ListResultDTO<ActionAttachmentDTO>> {
    let params = {};
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filters) {
      if (filters.search) params["search"] = "" + filters.search;
      if (filters.action_id) params["action_id"] = filters.action_id;
    }
    if (per_page) {
      params["per_page"] = "" + per_page;
      if (page) params["page"] = "" + page;
      return this.httpClient.get<ListResultDTO<ActionAttachmentDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      });
    } else {
      return this.httpClient.get<ActionAttachmentDTO[]>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      }).pipe(
        map(results => {
          return {
            data: results,
            total: results.length
          };
        })
      );
    }
  }

  public show(id: number): Observable<ActionAttachmentDTO> {
    let params = { id: "" + id };
    return this.httpClient.get<ActionAttachmentDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }

  public upsert(action_attachment: ActionAttachmentDTO): Observable<ActionAttachmentDTO> {
    if (action_attachment.id) {
      return this.httpClient.post<ActionAttachmentDTO>(this.ROUTES.store,
        toFormData(action_attachment, true)
      );
    } else {
      return this.httpClient.post<ActionAttachmentDTO>(this.ROUTES.store,
        toFormData(action_attachment)
      );
    }
  }

  public delete(id: number): Observable<any> {
    let params = { id: "" + id };
    return this.httpClient.delete(this.ROUTES.destroy, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }
}
